"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentrySdk = void 0;
var tslib_1 = require("tslib");
// has to be import * as
var Sentry = tslib_1.__importStar(require("@sentry/browser"));
var sentrySdk = function () {
    return Sentry;
};
exports.sentrySdk = sentrySdk;
exports.sentrySdk.init = function (_a) {
    var dsn = _a.dsn;
    Sentry.init({ dsn: dsn });
};
